import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  container: {
    textDecoration: "none",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    flexBasis: "100%",
    flexGrow: 0,
    marginRight: 5,
    marginBottom: 20
  },
  textContainer: {
    flexGrow: 2
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[200],
    marginLeft: 10,
    width: "100%",
    display: "block"
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 400,
    color: colour.grey[200],
    marginLeft: 10,
    width: "100%",
    display: "block"
  },
  isOn: {
    fontSize: 12,
    color: colour.grey[400],
    marginTop: 5,
    marginLeft: 10
  },
  onHightlight: {
    color: "#FFFFFF",
    background: colour.brand.green,
    borderRadius: 10,
    padding: "0px 5px 1px",
    fontSize: 12,
    fontWeight: 600,
    marginTop: 5,
    textAlign: "center"
  },
  arrow: {
    fontFamily: "informetis",
    fontSize: 20,
    color: colour.grey[200]
  }
});
